import { render, staticRenderFns } from "./PublicKnowledgeBaseCard.vue?vue&type=template&id=7b9f07f4&scoped=true&"
import script from "./PublicKnowledgeBaseCard.vue?vue&type=script&lang=js&"
export * from "./PublicKnowledgeBaseCard.vue?vue&type=script&lang=js&"
import style0 from "./PublicKnowledgeBaseCard.vue?vue&type=style&index=0&id=7b9f07f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9f07f4",
  null
  
)

export default component.exports